<template>
    <div class="q-mt-md q-gutter-y-md">
        <q-card>
            <q-tabs
                v-model="activeTab"
                class="primary bg-grey-3"
                active-color="primary"
                indicator-color="primary"
                align="justify"
            >
                <q-tab :label="$t('Causes')" name="causes" />
                <q-tab :label="$t('Categories')" name="categories" />
            </q-tabs>

            <q-separator></q-separator>

            <q-tab-panels v-model="activeTab" animated keep-alive>
                <q-tab-panel name="causes" class="tab-panel">
                    <cause-list :facilityId="facilityId"></cause-list>
                </q-tab-panel>
                <q-tab-panel name="categories" class="tab-panel">
                    <category-list :facilityId="facilityId"></category-list>
                </q-tab-panel>
            </q-tab-panels>
        </q-card>
    </div>
</template>

<script>
import BreadcrumbsManager from '@mixins/BreadcrumbsManager.vue';
import CauseList from './CauseList.vue';
import CategoryList from './CategoryList.vue';
import { mapState } from 'pinia';
import { useFacilitiesStore } from '@stores/facilities.ts';

export default {
    name: 'CauseTabs',
    components: { CauseList, CategoryList },
    mixins: [BreadcrumbsManager],
    props: {
        facilityId: {
            type: [String, Number],
            required: true
        }
    },
    mounted() {
        // set breadcrumbs
        const facility = this.getFacility(this.facilityId);
        // set breadcrumbs
        this.setBreadcrumbs([
            {
                label: this.$t('Facilities'),
                route: {
                    name: 'facility_list'
                }
            },
            {
                label: facility.name,
                route: {
                    name: 'facility_dashboard',
                    params: {
                        facilityId: facility.id
                    }
                }
            },
            {
                label: this.$t('Settings'),
                route: {
                    name: 'facility_settings',
                    params: {
                        facilityId: facility.id
                    }
                }
            },
            {
                label: this.$t('Downtime Causes')
            }
        ]);
    },
    data() {
        return {
            activeTab: 'causes'
        };
    },
    computed: {
        ...mapState(useFacilitiesStore, ['getFacility'])
    }
};
</script>

<style lang="scss" scoped></style>
